module.exports = __webpack_public_path__ + "static/ab8-bbef52214dc50e5c61dfb9a825788d2b.png";